// LineChart.js
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['data', 'options'],
  mounted () {
    this.renderChart(this.buildData(), this.buildOptions())
  },
  methods: {
    getGradient (color) {
      let gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 300)
      gradient.addColorStop(0, color + 'BB')
      gradient.addColorStop(0.5, color + '55')
      gradient.addColorStop(1, color + '11')
      return gradient
    },
    buildData() {
      let builtData = this.data
      builtData.datasets.forEach(dataset => {
        dataset.borderColor = dataset.backgroundColor
        dataset.borderWidth = 2
        dataset.pointBackgroundColor = 'white'
        dataset.backgroundColor = this.getGradient(dataset.backgroundColor)
      });
      
      return builtData;
    },
    buildOptions() {
      let builtOptions = {
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }]
        },
        elements: {
          line: {
            tension: 0.3,
          }
        },
        plugins: {
					datalabels: {
            display: false,
          }
				},
      }
      this.$lodash.merge(builtOptions, this.options)
      return builtOptions;
    }
  },
  watch: {
    data: function() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.buildData(), this.buildOptions())
    }
  }
}
